import { render, staticRenderFns } from "./resetpsd.vue?vue&type=template&id=85a18baa&scoped=true"
import script from "./resetpsd.vue?vue&type=script&lang=js"
export * from "./resetpsd.vue?vue&type=script&lang=js"
import style0 from "./resetpsd.vue?vue&type=style&index=0&id=85a18baa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a18baa",
  null
  
)

export default component.exports